<div id="points">
    <div class="container-fluid text-center mt-3">
        <div class="btn-group " role="group" aria-label="Message Button Group">
            <button type="button" 
            class="btn mr-1" 
            id="motive-btn" 
            data-toggle="collapse" 
            data-target="#motive" 
            aria-expanded="true" 
            aria-controls="Our Main Motive"
            (click)="showCard(1)">Our Main Motive</button>

            <button type="button" 
            class="btn mr-1" 
            id="theory-btn" 
            data-toggle="collapse" 
            data-target="#theory" 
            aria-expanded="true" 
            aria-controls="Our Theory"
            (click)="showCard(2)">Our Theory</button>

            <button type="button" 
            class="btn mr-1" 
            id="pre-btn" 
            data-toggle="collapse" 
            data-target="#pre" 
            aria-expanded="true" 
            aria-controls="Pre-kindergarten"
            (click)="showCard(3)">Pre-kindergarten</button>

        </div>

        <!-- Message 1 -->
        <div class="row collapse show multi-collapse" id="motive">
            <div class="col-12 py-5 px-md-5 detail-box">
                <div class="message-detail">
                    <p class="text-left">Provide quality education to children with minimum financial burden on the Parent. We provide students with an immersive, collaborative, and inspiring environment where they can develop a broadly informed, highly disciplined intellect that will help them be successful in whatever work they finally choose.</p>
                  </div>
            </div>
           
        </div>

        <!-- Message 2 -->
        <div class="row collapse  multi-collapse" id="theory">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail">
                    <p class="text-left">We believe that children are active participants in their own learning. That’s why we encourage them to ask questions and explore the world around them.</p>
                    <p class="text-left">We also focus on essential life skills such as communication and self-regulation. Plus, children are routinely encouraged to take on challenges, develop their own learning goals, see situations from different perspectives etc.
                    </p>
                  </div>
            </div>
          
        </div>

        <!-- Message 3 -->
        <div class="row collapse multi-collapse" id="pre">
            <div class="col-12  py-5 px-md-5 detail-box">
                <div class="message-detail">
                    <p class="text-left">Our Pre-Kindergarten classroom is designed to help your child make significant developmental gains, communicate more successfully, and work well both independently and in group situations. Building on Preschool learning, Pre-K learning focuses on problem-solving, responsive listening and language usage, as well as social and collaborative skills, with specific lessons in Reading, Writing, Math etc.</p>
                    <p class="text-left">Each child is different, therefore special. Keeping this in focus, we endeavor to develop all the attributes & skills of the children in a holistic manner so that they adapt themselves to the constantly changing environment.
                         To inculcate creativity & critical thinking in order to encourage logical decision making & innovation, the school is all prepared to implement NEW EDUCATION POLICY.</p>
                  </div>
            </div>
           
        </div>
       
    </div>
</div>